import React, { useState } from 'react';
import { Button, Input, Typography } from '@material-tailwind/react';
import { MagnifyingGlassIcon, TrashIcon } from '@heroicons/react/24/outline';

const TIPOS = [
    { value: '', label: 'Todos' },
    { value: '1', label: 'Sede Central' },
    { value: '0', label: 'Regional' },
]

const ESTADOS = [
    { value: '', label: 'Todos' },
    { value: 'activo', label: 'Activo' },
    { value: 'desactivado', label: 'Desactivado' },
]

const normalizar = (valor) => String(valor ?? '').trim().toLowerCase()

export const Cabecera = ({ filtrarLista, resetearLista, perfiles = [], regiones = [] }) => {

    const [texto, setTexto] = useState('')
    const [tipo, setTipo] = useState('')
    const [perfil, setPerfil] = useState('')
    const [region, setRegion] = useState('')
    const [estado, setEstado] = useState('')

    const buscar = () => {
        const textoBuscado = normalizar(texto)

        const callback = (item) => {
            const coincideTexto = textoBuscado === ''
                || normalizar(item.nombre).includes(textoBuscado)
                || normalizar(item.nombre_usuario).includes(textoBuscado)

            const coincideTipo = tipo === '' || String(Number(item.sede_admin)) === tipo
            const coincidePerfil = perfil === '' || normalizar(item.rol_sede) === normalizar(perfil)
            const coincideRegion = region === '' || String(item.id_region ?? '') === region
            const coincideEstado = estado === '' || normalizar(item.estado) === estado

            return coincideTexto && coincideTipo && coincidePerfil && coincideRegion && coincideEstado
        }

        filtrarLista(callback)
    }

    const limpiar = () => {
        setTexto('')
        setTipo('')
        setPerfil('')
        setRegion('')
        setEstado('')
        resetearLista && resetearLista()
    }

    const hayFiltros = texto !== '' || tipo !== '' || perfil !== '' || region !== '' || estado !== ''

    return <div className='w-full flex flex-col gap-4'>
        <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4'>
            <div className='flex flex-col'>
                <Typography variant="small" className="mb-1 font-medium">Nombre o usuario</Typography>
                <Input
                    type="text"
                    color="black"
                    value={texto}
                    placeholder="Buscar..."
                    onChange={(e) => setTexto(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter') buscar() }}
                    className="!border-t-blue-gray-200 focus:!border-t-gray-900"
                    labelProps={{ className: "before:content-none after:content-none" }}
                />
            </div>

            <div className='flex flex-col'>
                <Typography variant="small" className="mb-1 font-medium">Tipo</Typography>
                <select className='select-bg-ui w-full h-10' value={tipo} onChange={(e) => setTipo(e.target.value)}>
                    {TIPOS.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
                </select>
            </div>

            <div className='flex flex-col'>
                <Typography variant="small" className="mb-1 font-medium">Perfil</Typography>
                <select className='select-bg-ui w-full h-10' value={perfil} onChange={(e) => setPerfil(e.target.value)}>
                    <option value="">Todos</option>
                    {perfiles.map(item => (
                        <option key={item.id_usuario_perfil ?? item.nro_perfil} value={item.nombre}>{item.nombre}</option>
                    ))}
                </select>
            </div>

            <div className='flex flex-col'>
                <Typography variant="small" className="mb-1 font-medium">Región</Typography>
                <select className='select-bg-ui w-full h-10' value={region} onChange={(e) => setRegion(e.target.value)}>
                    <option value="">Todas</option>
                    {regiones.map(item => (
                        <option key={item.id_region} value={item.id_region}>{item.nombre ?? item.id_region}</option>
                    ))}
                </select>
            </div>

            <div className='flex flex-col'>
                <Typography variant="small" className="mb-1 font-medium">Estado</Typography>
                <select className='select-bg-ui w-full h-10' value={estado} onChange={(e) => setEstado(e.target.value)}>
                    {ESTADOS.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
                </select>
            </div>
        </div>

        <div className='flex justify-center lg:justify-end gap-2'>
            {hayFiltros && (
                <Button size="lg" variant="outlined" color="blue-gray" className="rounded flex items-center" onClick={limpiar}>
                    <TrashIcon className="h-4 w-4 mr-2" />Limpiar filtros
                </Button>
            )}
            <Button size="lg" color="blue" className="rounded flex items-center" onClick={buscar}>
                <MagnifyingGlassIcon className="h-4 w-4 mr-2" />Buscar
            </Button>
        </div>
    </div>
}
